import http from '@/api/common'

export default {
  getReportTranslations(code) {
    return http.get(`app/GetReportTranslations?code=${code}`)
  },
  saveTranslations(data) {
    return http.post('app/SaveReportTranslations', data)
  },
  translateAllReportSections(code) {
    return http.get(`app/TranslateAllReportSections?code=${code}`)
  },

  getServiceElementTranslations(cultureCode) {
    return http.get(`app/GetServiceElementTranslations?cultureCode=${cultureCode}`)
  },
  saveServiceElementTranslations(data) {
    return http.post('app/SaveServiceElementTranslations', data)
  },
  translateAllServiceElements(cultureCode) {
    return http.get(`app/TranslateAllServiceElements?cultureCode=${cultureCode}`)
  },
  localeTranslation(data) {
    console.log('API Locale Translation', data)
    return http.post('app/AppLabelTranslations', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/translation.js